import styled from "styled-components";
import { theme } from "../../../styles";
import { Stack, TabPanel } from "@safetyculture/sc-web-ui";
import * as React from "react";
import { TabOverview } from "./TabOverview";
import { UseQueryResult } from "react-query";
import { IClaim } from "../../../types";
import { TabSettings } from "./TabSettings";
import { Cog } from "@safetyculture/icons-react";
import { feature_flag } from "../../../constants";
import { useFlag } from "../../../config/featureFlags";
import { useUrlActiveTab } from "../../../hooks/useUrlActiveTab";

type Props = {
  claim_query: UseQueryResult<IClaim | undefined>;
  active_tab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
};

export const ClaimDetailsTabs: React.FC<Props> = ({
  claim_query,
  active_tab,
  setActiveTab,
}) => {
  const claims_create_inspection_flag = useFlag(
    feature_flag.CREATE_CLAIM_INSPECTION,
  );

  return (
    <StyledTabPanel
      active={active_tab}
      onTabChange={setActiveTab}
      variant="border"
    >
      <TabPanel.Panel label="Details" name="/details">
        <TabOverview claim_query={claim_query} />
      </TabPanel.Panel>
      {claims_create_inspection_flag && (
        <TabPanel.Panel
          label={
            <Stack align="center" direction="row" spacing="s1">
              <Cog size={16} />
              Settings
            </Stack>
          }
          name="/settings"
        >
          <TabSettings claim_query={claim_query} />
        </TabPanel.Panel>
      )}
    </StyledTabPanel>
  );
};

const StyledTabPanel = styled(TabPanel)`
  border-bottom: 1px solid ${theme.color.surface.border.weak.default};
  padding-bottom: 0;
  justify-content: space-between;
`;
